export default __webpack_public_path__ + "static/media/logo.61ee6322.svg";